import Button from "@edaz/edazkit/Button";
import { IconType } from "@edaz/edazkit/Icon";
import type { PropertyName } from "@frui.ts/helpers/dist";
import { View } from "@frui.ts/views";
import { observer, Observer } from "mobx-react-lite";
import type { ReactNode } from "react";
import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import type EditableRowViewModel from "../../viewModels/editableRowViewModel";

export interface EditableCellProps<TEntity = any> {
  vm?: EditableRowViewModel<TEntity>;
  property?: PropertyName<TEntity>;
  children: ReactNode;
}

function EditableCell<TEntity>(props: EditableCellProps<TEntity>) {
  const { children, vm, property } = props;

  const onClick = () => {
    if (vm) {
      vm.editedProperty = property;
    }
  };

  const popover = (
    <Popover id="edit-popover" className="inline-edit-popover">
      <Popover.Content>
        <Observer>{() => <View vm={vm} useLifecycle={true} />}</Observer>
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger show={vm?.editedProperty === property} rootClose={false} trigger="click" placement="left" overlay={popover}>
      <div>
        {children}
        {vm?.isEditable && (
          <Button
            key="edit"
            iconLeft={IconType.Edit}
            disabled={false}
            variant="inline-icon"
            size="sm"
            className="rounded"
            onClick={onClick}
          />
        )}
      </div>
    </OverlayTrigger>
  );
}

export default observer(EditableCell);
